import React from 'react';

import TestimonialCard, { type TestimonialCardProps } from './TestimonialCard';
import Button from '../Button';

type CtaProps = {
  text: string;
  url: string;
};

export type TestimonialSectionProps = {
  testimonials: TestimonialCardProps[];
  cta: CtaProps;
};

export default function TestimonialSection({ testimonials, cta }: TestimonialSectionProps) {
  return (
    <div id="testimonial-section" className="border-b border-rp-primary-redesign w-full">
      <div className="flex flex-col gap-6 px-4 pb-16 d:mt-135 d:pb-0 d:mb-12 d:px-0 d:mx-122">
        <h1 className="text-2xl d:text-32">From daycationers like you</h1>
        <div className="flex flex-col gap-12">
          {testimonials.map((testimonial) => (
            <TestimonialCard
              imageUrl={testimonial.imageUrl}
              clientName={testimonial.clientName}
              description={testimonial.description}
              hotelName={testimonial.hotelName}
              product={testimonial.product}
              rating={testimonial.rating}
              key={testimonial.clientName}
              url={testimonial.url}
            />
          ))}
          <Button
            size="lg"
            color="primary"
            fullScreen
            type="link"
            href={cta.url}
            classes="block d:hidden"
          >
            {cta.text}
          </Button>
          <Button size="lg" color="primary" type="link" href={cta.url} classes="hidden d:block">
            {cta.text}
          </Button>
        </div>
      </div>
    </div>
  );
}
